module.exports = __webpack_public_path__ + "officialStatic/img/step-bg.318c5ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/step-bg.jpg
// module id = 7iPp
// module chunks = 0